import { Application, Controller } from "stimulus"

export default class CookiesNoticeController extends Controller {
  static targets = ["bannerCookiesContainer", "acceptAndRejectButtonsContainer", 
                    "saveButtonContainer", "searchForm"]
  
  click() {
    this.acceptAndRejectButtonsContainerTarget.classList.remove("d-flex")
    this.acceptAndRejectButtonsContainerTarget.classList.add("d-none")
    this.saveButtonContainerTarget.classList.remove("d-none")
  }

  close() {
    this.bannerCookiesContainerTarget.classList.add("d-none")
    gtag("consent", "update", { "ad_storage": "granted", "analytics_storage": "granted" })
    gtag("event", "page_view", {})
    window.bsht_edit_privacy_settings_sheet?.desactivate();
  }

  submitForm() {
    if (this.optionsChecked()) {
      if(this.searchFormTarget.requestSubmit) {
        this.searchFormTarget.requestSubmit();
      }else {
        this.searchFormTarget.dispatchEvent(new CustomEvent('submit', {bubbles: true}))
      }
      this.close();
    }
  }

  optionsChecked() {
    return document.querySelectorAll('input[type=radio]:checked').length == 2;
  }
}

const application = Application.start()
application.register("cookies-notice", CookiesNoticeController)
